const organization_details = {
    departments: {
        leader: '책임자',
        leaders: '부서 책임자',
        led_departments: '담당 부서',
        edit_leaders: '책임자 관리',
        add_leader: '추가',
        remove_leader: '제거',
        no_leaders: '책임자 없음',
        local: '로컬 관리',
        managed_members: '관리 범위의 구성원',
        leader_scope_hint: '담당 부서와 하위 부서의 소속을 관리합니다.',
        leader_permission_hint: '책임자는 담당 부서와 하위 부서의 소속을 관리하며 조직 역할이나 부서 구조를 변경할 수 없습니다.',
        primary_synced: '주 부서는 Feishu에서 관리합니다.',
        status_active: '재직',
        status_suspended: '정지됨',
        status_departed: '퇴사',
        status_pending: '활성화 대기',
        search: '검색',
        previous_page: '이전 페이지',
        next_page: '다음 페이지',
        directory_title: '조직 구성원',
        member_name: '구성원',
        search_members: '이름 또는 사용자 이름으로 검색',
        include_descendants: '하위 부서 포함',
        no_members: '일치하는 구성원이 없습니다.',
        all_members: '모든 구성원',
        all_departments: '모든 부서',
        edit_member: '소속 부서 편집',
        add_child: '하위 부서 추가',
        expand_department: '{{name}} 펼치기',
        collapse_department: '{{name}} 접기',
        title: '부서',
        description: '이 조직의 부서와 구성원 소속을 관리합니다.',
        create: '부서 만들기',
        edit: '부서 편집',
        name: '부서 이름',
        parent: '상위 부서',
        root: '상위 부서 없음',
        id: '부서 ID',
        members: '구성원 부서',
        member_id: '구성원 사용자 ID',
        primary: '주 부서',
        none: '설정 안 됨',
        assignments: '부서 소속 기록',
        no_assignments: '아직 부서 소속 기록이 없습니다.',
        assignment_hint: '로컬 부서와 선택적으로 주 부서를 지정합니다. 디렉터리 소속은 읽기 전용입니다.',
        empty: '아직 부서가 없습니다.',
        readonly: '부서와 내 소속을 확인할 수 있습니다. 변경하려면 조직 관리자에게 문의하세요.',
        load_error: '데이터를 불러올 수 없습니다. 다시 시도하세요.',
        mutation_error: '저장할 수 없습니다. 권한, 조직 소속 및 부서 계층을 확인하세요.',
        loading: '불러오는 중…',
        synced: '디렉터리 관리',
        choose: '부서 검색',
        organizations_title: '조직 및 부서',
        organizations_description: '조직을 선택하여 부서를 보거나 관리하세요.',
        no_organizations: '가입한 조직이 없습니다. 조직 관리자에게 문의하세요.',
        organization: '현재 조직',
        choose_organization: '조직 선택',
        delete_title: '부서 삭제',
        delete_description: '“{{name}}” 부서를 삭제할까요? 먼저 구성원과 하위 부서를 이동하세요.',
    },
    directory: {
        leaders_label: '부서 책임 관계',
        local_department_leader: '로컬 부서 책임자',
        status_active: '재직',
        status_suspended: '정지됨',
        status_departed: '퇴사',
        status_pending: '활성화 대기',
        profiles_label: '원본 프로필',
        primary_label: '주 부서 변경',
        deactivated_label: '비활성 조직 신원',
        reactivated_label: '재활성 조직 신원',
        lifecycle_notice: '유지되는 역할 할당: {{count}}개. 신원을 다시 활성화하면 기존 권한이 복원됩니다.',
        title: 'Feishu 디렉터리',
        description: 'Feishu 커넥터를 사용하여 이 조직으로 부서와 구성원을 가져옵니다.',
        identity_notice: '디렉터리 프로비저닝이 활성화된 커넥터를 사용하세요. 기존 커넥터의 식별 방식을 변경하려면 계정 마이그레이션이 필요합니다.',
        connector: 'Feishu 커넥터 ID',
        preview: '동기화 미리 보기',
        preview_title: '동기화 미리 보기',
        preview_description: '가져오기 전에 디렉터리를 확인하세요. 변경되면 다시 미리보기를 실행하세요.',
        import: '동기화 확인',
        success: '부서 {{departments}}개와 구성원 {{users}}명을 가져왔으며 계정 {{createdUsers}}개를 만들었습니다. 부서 {{removedDepartments}}개, 멤버십 {{removedMemberships}}개, 소속 {{removedAssignments}}개를 제거했습니다.',
        failure: '디렉터리를 읽거나 가져올 수 없습니다. 커넥터 권한과 공개 범위를 확인한 후 다시 미리보기를 실행하세요.',
        behavior_title: '가져오기 방식',
        mode: '이름, 아바타, 부서 및 주 부서를 동기화합니다. 누락되거나 비활성인 구성원은 현재 조직의 접근 권한만 잃으며 역할, 수동 소속, 전역 계정 및 다른 조직 신원은 유지됩니다. 이메일과 전화번호는 원본 정보로만 저장되며 로그인 자격 증명으로 연결되지 않습니다.',
        limits: '한 번에 부서 1000개, 사용자 5000명, 소속 10000건까지이며 읽기 제한은 60초입니다. 불완전하거나 한도를 넘으면 거부됩니다.',
        counts: '부서 {{departments}}개 · 구성원 {{users}}명',
        departments_label: '부서',
        members_label: '조직 멤버십',
        assignments_label: '부서 소속',
        item: '항목',
        added: '추가',
        updated: '업데이트',
        removed: '제거',
        cleanup_notice: '이름, 아바타, 부서 및 주 부서를 동기화합니다. 누락되거나 비활성인 구성원은 현재 조직의 접근 권한만 잃으며 역할, 수동 소속, 전역 계정 및 다른 조직 신원은 유지됩니다. 이메일과 전화번호는 원본 정보로만 저장되며 로그인 자격 증명으로 연결되지 않습니다.',
        conflicts_title: '충돌 {{count}}개로 동기화할 수 없습니다. 로컬 종속성을 해결하고 다시 미리 보세요.',
        removals_title: '제거 항목 예시(분류별 최대 20개)',
        local_child_department: '로컬 하위 부서',
        unowned_assignment: '로컬 또는 출처가 확인되지 않는 기존 소속',
        local_member_roles: '멤버에게 로컬에서 할당한 역할이 있음',
        unlinked_identity: '디렉터리 신원 연결이 해제됨',
    },
    page_title: '조직 세부 정보',
    delete_confirmation: '삭제하면 모든 회원이 이 조직에서 멤버십과 역할을 잃게 됩니다. 이 작업은 취소할 수 없습니다.',
    organization_id: '조직 ID',
    settings_description: '조직은 귀하의 응용 프로그램에 액세스할 수 있는 팀, 비즈니스 고객 및 협력업체를 나타냅니다.',
    name_placeholder: '조직의 이름, 고유할 필요는 없습니다.',
    description_placeholder: '조직에 대한 설명입니다.',
    member: '멤버',
    member_other: '멤버',
    add_members_to_organization: '조직 {{name}}에 멤버 추가',
    add_members_to_organization_description: '이름, 이메일, 전화 또는 사용자 ID를 검색하여 적절한 사용자를 찾습니다. 기존 멤버는 검색 결과에 표시되지 않습니다.',
    add_with_organization_role: '조직 역할로 추가',
    user: '사용자',
    application: '응용 프로그램',
    application_other: '응용 프로그램들',
    add_applications_to_organization: '조직 {{name}}에 응용 프로그램 추가',
    add_applications_to_organization_description: '앱 ID, 이름 또는 설명을 검색하여 적절한 응용 프로그램을 찾습니다. 기존 응용 프로그램은 검색 결과에 표시되지 않습니다.',
    at_least_one_application: '최소한 하나의 응용 프로그램이 필요합니다.',
    remove_application_from_organization: '조직에서 응용 프로그램 제거',
    remove_application_from_organization_description: '제거하면 응용 프로그램은 이 조직에서의 연관성과 역할을 잃게 됩니다. 이 작업은 취소할 수 없습니다.',
    search_application_placeholder: '앱 ID, 이름 또는 설명으로 검색',
    roles: '조직 역할',
    authorize_to_roles: '{{name}}에게 다음 역할에 대한 액세스 권한 부여:',
    edit_organization_roles: '조직 역할 편집',
    edit_organization_roles_title: '{{name}} 의 조직 역할 편집',
    remove_user_from_organization: '사용자를 조직에서 제거',
    remove_user_from_organization_description: '제거하면 사용자가 이 조직에서 멤버십과 역할을 잃습니다. 이 작업은 취소할 수 없습니다.',
    search_user_placeholder: '이름, 이메일, 전화 또는 사용자 ID로 검색',
    at_least_one_user: '최소한 한 명의 사용자가 필요합니다.',
    organization_roles_tooltip: '이 조직 내의 {{type}} 에 할당된 역할입니다.',
    custom_data: '사용자 정의 데이터',
    custom_data_tip: '사용자 정의 데이터는 조직과 관련된 추가 데이터를 저장하는 데 사용할 수 있는 JSON 객체입니다.',
    invalid_json_object: '잘못된 JSON 객체입니다.',
    branding: {
        name: '브랜딩',
        description: '조직 수준의 로그인 경험을 사용자 지정합니다.',
        organization_level_sie: '조직 수준 로그인 경험',
        organization_level_sie_switch: '조직 수준 로그인 경험을 활성화하고 조직 전용 브랜딩을 설정합니다. 비활성화 시 먼저 애플리케이션 수준 로그인으로, 그 다음 통합 로그인 경험으로 폴백합니다.',
        logo: '조직 로고',
        logo_tooltip: '조직 ID를 전달하여 로그인 경험에서 이 로고를 표시할 수 있습니다. 어두운 모드가 활성화되어 있는 경우 어두운 버전의 로고가 필요합니다. <a>자세히 알아보기</a>',
    },
    jit: {
        title: '즉시 프로비저닝',
        description: '일부 인증 방법을 통해 처음으로 로그인할 때 사용자가 자동으로 조직에 가입되고 역할이 할당될 수 있습니다. 즉시 프로비저닝을 위한 요구 사항을 설정할 수 있습니다.',
        email_domain: '이메일 도메인 프로비저닝',
        email_domain_description: '확인된 이메일 주소를 사용하여 회원가입하거나 확인된 이메일 주소를 사용하여 소셜 로그인을 하는 신규 사용자는 자동으로 조직에 가입됩니다. <a>자세히 알아보기</a>',
        email_domain_placeholder: '즉시 프로비저닝을 위한 이메일 도메인을 입력하세요',
        invalid_domain: '잘못된 도메인',
        domain_already_added: '도메인이 이미 추가되었습니다',
        sso_enabled_domain_warning: '엔터프라이즈 SSO와 연관된 하나 이상의 이메일 도메인을 입력했습니다. 이 이메일을 가진 사용자는 표준 SSO 흐름을 따르게 되며, 엔터프라이즈 SSO 프로비저닝이 설정되지 않은 한 이 조직에 프로비저닝되지 않습니다.',
        enterprise_sso: '엔터프라이즈 SSO 프로비저닝',
        no_enterprise_connector_set: '아직 엔터프라이즈 SSO 커넥터를 설정하지 않았습니다. 먼저 커넥터를 추가하여 엔터프라이즈 SSO 프로비저닝을 활성화하십시오. <a>설정</a>',
        add_enterprise_connector: '엔터프라이즈 커넥터 추가',
        enterprise_sso_description: '처음으로 엔터프라이즈 SSO를 통해 로그인하는 신규 사용자나 기존 사용자는 자동으로 조직에 가입됩니다. <a>자세히 알아보기</a>',
        organization_roles: '기본 조직 역할',
        organization_roles_description: '즉시 프로비저닝을 통해 조직에 가입할 때 사용자에게 할당할 역할입니다.',
    },
    mfa: {
        title: '다중 인증 (MFA)',
        tip: 'MFA가 필요할 때, MFA가 설정되지 않은 사용자는 조직 토큰을 교환하려고 시도할 때 거부됩니다. 이 설정은 사용자 인증에 영향을 미치지 않습니다.',
        description: '이 조직에 액세스하기 위해 사용자가 다중 인증을 설정해야 합니다.',
        no_mfa_warning: '테넌트에 다중 인증 방법이 활성화되어 있지 않습니다. 하나 이상의 <a>다중 인증 방법</a>이 활성화될 때까지 사용자는 이 조직에 액세스할 수 없습니다.',
    },
};
export default Object.freeze(organization_details);
